import React from 'react'

export const InterviewsCreatorHandlersContext = React.createContext(undefined)
export const InterviewsCreatorStateContext = React.createContext(undefined)
